import React, {ChangeEventHandler, useEffect, useState} from "react";
import {Box, Button, Grid, Stack, Typography} from "@mui/material";
// @ts-ignore
import logo from "../assets/img/ep_slide_logo.png";
import {RoutesList} from "../Modules/RoutesList";
import {useNavigate} from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import RmpServices, {ISignUp} from "../services"
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import Input from "@mui/material/Input";
import {Text} from "recharts";




export const SignUp = () =>{


    const history = useNavigate()

    const [user,setUser] = useState<ISignUp>({
        "first_name":"",
        "last_name":"",
        "password":"",
        "dob": "",
        "email":""
    })

    const [wasOpened, setWasOpened] = useState<boolean>(false);

    const [loader,setLoader] = useState<boolean>(false)

    const [validationDate,setValidationDate] = useState({message: '',error:false})

    const [err,setError] = useState('')

    const handleSignUp = () => {
        if(validationDate.error)
            return false

        setLoader(true)
        setError("")
        RmpServices.SignUp(user)
            .then(response=>{
                localStorage.setItem("signUpMessage","Account registered please login")
                history(RoutesList.Login.path)
            })
            .catch(error=>{
                setError(error.response.data.errors[0].msg)
                setLoader(false)
            })
    }

    const OnDateChange = (newValue:Date) => {

        if(newValue === null)
            return false

        if(wasOpened){
            setUser(prevState => {
                return {...prevState,dob:newValue.toISOString().split('T')[0]!}
            })
        }
        else{
            var timestamp = Date.parse(newValue !==null ? newValue.toString() : '');

            if(newValue > new Date()){
                setValidationDate({message: 'red',error:true})
                return false
            }

            if (isNaN(timestamp) == false) {
                setValidationDate({message: '',error:false})
                let date = new Date(newValue.setDate(newValue.getDate() + 1))
                setUser(prevState => {
                    return {...prevState,dob:date.toISOString().split('T')[0]!}
                })

            }
        }
    }

    const onDateType = (value:Date) =>{
        setUser(prevState => {
            return {...prevState,dob:value.toISOString().split('T')[0]!}
        })
    }


    const handleInputChange = (e : React.ChangeEvent<HTMLInputElement>) =>{
        setUser(prevState => {
            return { ...prevState, [e.target.name] : e.target.value }
        })
    }
    return(
        <Box
            className = "login-page"
        >

            <Grid container width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"center"}>
                <Grid
                    container
                    item
                    md={6}
                    sm={5}
                    lg={3}
                    xs={15}
                    className={"login-card"}
                    padding={5}
                    direction={"column"}
                    spacing={3}
                    // height={700}
                >
                    <Grid display={"flex"} justifyContent={"center"} width={"100%"} >
                        <div className = "logo-portrait-login">
                            <img src={logo}/>
                        </div>
                    </Grid>
                    <Grid item container display={"flex"} width={"100%"} direction={"column"}>
                        <Typography fontSize={32} color={"#089BAB"} fontWeight={700}>
                            Welcome
                        </Typography>
                        <Typography color={err.length>0 ? "red" : "#8F95B2"} fontSize={16} fontWeight={700}>
                            { err.length>0 ? err : "Enter your details to sign up" }
                        </Typography>
                    </Grid>

                    <Grid item width={"100%"}>
                        <Stack width={"100%"} direction={"column"} spacing={2}>
                            <Typography fontSize={14}>
                                First Name
                            </Typography>
                            <input value={user.first_name}  placeholder={"Enter your first name"} className={"login-input"} name="first_name" onChange={handleInputChange} />
                            <Typography fontSize={14}>
                                Last Name
                            </Typography>
                            <input value={user.last_name} className={"login-input"} placeholder={"Enter your last name"} name="last_name" onChange={handleInputChange} />
                            <Typography fontSize={14}>
                                Email
                            </Typography>
                            <input value={user.email} placeholder={"Enter your email address"} className={"login-input"} name="email" onChange={handleInputChange} />
                            <Typography fontSize={14}>
                                Password
                            </Typography>
                            <input value={user.password} className={"login-input"} placeholder={"Enter your password"} name="password" type={"password"} onChange={handleInputChange} />
                            <Typography fontSize={14}>
                                Date of birth
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Custom input"
                                    value={user.dob}
                                    maxDate={new Date()}
                                    onChange={(newValue) => {
                                        OnDateChange(newValue!)
                                    }}
                                    // onError={()=>console.log("error")}
                                    onOpen={()=>setWasOpened(true)}
                                    onClose={()=>setWasOpened(false)}
                                    inputFormat={"dd/MM/yyyy"}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            background:"#FFFFFF",
                                            padding:"0px 10px",
                                            borderRadius:"12px",
                                            height:"40px",
                                            border:validationDate.message.length>0 ? "2px solid red" : "2px solid #E6E8F0",
                                            justifyContent:"space-between"
                                        }}>
                                            <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </LocalizationProvider>
                        </Stack>
                    </Grid>

                    <Grid item width={"100%"} marginTop={3}>
                        <Button
                            onClick={handleSignUp}
                            variant="contained"
                            sx={{
                                width:"100%",
                                borderRadius:"16px",
                                background:"#089BAB",
                                textTransform:"none",
                                color:"#F9FAFC",
                                fontWeight:700,
                                boxShadow:"none",
                                padding:1,
                                fontSize : "16px"
                            }}>SignUp
                            <CircularProgress sx={{position:"relative",left:"40px",color:"#FFFFFF",display:loader?" ":"none"}} size={25} thickness={6}/>
                        </Button>
                    </Grid>
                    <Grid item display={"flex"} justifyContent={"center"}
                    >
                        <Typography>
                            Already have an account?
                        </Typography>
                        <Typography
                            onClick={()=>history(RoutesList.Login.path)}
                            color={"#089BAB"}
                            style={{marginLeft:"10px",cursor:"pointer"}}
                        >
                            Login
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

        </Box>
    )
}